import {
  put, takeLatest,
} from 'redux-saga/effects'
import request from '@/helpers/axios'
import { CREATE_INTEGRATION } from '@/store/actions/installation'
import {
  INSTALLATIONS_INTEGRATION_ENDPOINT,
  generateGetProjectCard
} from '@/constants/apiRoutes'
import {
  successCreateIntegration,
} from '@/store/actions/installation/createIntegration'
import createNotifications from '@/helpers/notification'
import { INTEGRATION } from '@/constants/objectTypes'
import { setGlobalLoading } from '@/store/actions/appSettings'
import { requestGetRootElements } from '@/store/actions/installation/getRootElemenet'
import { buildInstallationNodePath } from '@/helpers/installationTreeNode'
import { refreshInstallationTreeParent } from '@/store/sagas/installation/refreshInstallationTreeParent'
import { buildInstallationViewParams } from '@/helpers/installationViewParams'
import { requestGetAllConnectedIntegrations } from '@/store/actions/dictionaries/connectedIntegrations'

function* createIntegrationSaga({ payload }) {
  const {
    formValues, values, setUrlFormValues, onComplete,
  } = payload
  const {
    name, integrationType,
  } = values
  const toast = createNotifications()
  try {
    yield put(setGlobalLoading(true))
    const { data: parentProjectData } = yield request({
      url: generateGetProjectCard(formValues.id),
      method: 'get',
    })
    const body = {
      parentId: parentProjectData.id,
      parentName: parentProjectData.parentName,
      name,
      integrationType,
    }
    const { data } = yield request({
      url: INSTALLATIONS_INTEGRATION_ENDPOINT,
      method: 'post',
      body,
    })
    const {
      rootId, FILTER, path,
    } = formValues

    const integrationPath = buildInstallationNodePath(path, data.id)

    const treeRefreshed = yield refreshInstallationTreeParent({
      parentId: data.parentId,
      nodeId: data.id,
      path,
    })

    if (!treeRefreshed) {
      yield put(requestGetRootElements())
    }

    setUrlFormValues(buildInstallationViewParams({
      id: data.id,
      type: INTEGRATION,
      integrationType: data.integrationType,
      parentGeoZoneId: parentProjectData.parentId,
      rootId,
      parentTreeId: data.parentId,
      ...(integrationPath ? { path: integrationPath } : {}),
      FILTER,
    }))
    yield put(setGlobalLoading(false))
    toast({
      title: 'Создание интеграции',
      type: 'success',
      description: 'Интеграция успешно создана.',
    })
    yield put(requestGetAllConnectedIntegrations())

    if (onComplete) {
      onComplete()
    }

    yield put(successCreateIntegration())
  } catch (error) {
    const { FILTER } = formValues
    setUrlFormValues({ FILTER })
    console.log('function*createIntegrationSaga -> error', error)
    yield put(setGlobalLoading(false))
    toast({
      title: 'Ошибка операции!',
      description: 'Не удалось создать интеграцию. Повторите попытку позже.',
      type: 'error',
    })
  }
}

export default function* root() {
  yield takeLatest(CREATE_INTEGRATION.REQUEST, createIntegrationSaga)
}
